<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.staff_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.staff_del">删除</el-button>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item">
                    <el-input v-model="data.name" size="small" placeholder="请输入员工姓名" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                    <el-table-column prop="phone" label="电话" width="180"></el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.staff_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.staff_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="姓名"
                    :label-width="formLabelWidth"
                    prop="name"
                    :rules="[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话"
                    :label-width="formLabelWidth"
                    prop="phone"
                    :rules="[
                    { required: true, message: '请输入电话', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {StaffIndex, StaffAdd, StaffDel} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    name: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增员工",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    name: "",
                    phone: "",
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                StaffIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        StaffAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    name: data.name,
                    phone: data.phone,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑员工" : "新增员工"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    name: "",
                    phone: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增员工"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    StaffDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
        }
    }
</script>

<style>
</style>
